/*Contains ajaxInclude and extendAjaxInclude*/
/*! Ajax-Include - v0.1.3 - 2014-05-21
 * http://filamentgroup.com/lab/ajax_includes_modular_content/
 * Copyright (c) 2014 @scottjehl, Filament Group, Inc.; Licensed MIT */
(function( $, win, undefined ){
 
    var AI = {
        boundAttr: "data-ajax-bound",
        interactionAttr: "data-interaction",
        // request a url and trigger ajaxInclude on elements upon response
        makeReq: function( url, els, isHijax ) {
            $.get( url, function( data, status, xhr ) {
                els.trigger( "ajaxIncludeResponse", [ data, xhr ] );
            });
        },
        plugins: {}
    };
 
    $.fn.ajaxInclude = function( options ) {
        var urllist = [],
            elQueue = $(),
            o = {
                proxy: null
            };
 
        // Option extensions
        // String check: deprecated. Formerly, proxy was the single arg.
        if( typeof options === "string" ){
            o.proxy = options;
        }
        else {
            o = $.extend( o, options );
        }
 
        // if it's a proxy, que the element and its url, if not, request immediately
        function queueOrRequest( el ){
            var url = el.data( "url" );
            if( o.proxy && $.inArray( url, urllist ) === -1 ){
                urllist.push( url );
                elQueue = elQueue.add( el );
            }
            else{
                AI.makeReq( url, el );
            }
        }
 
        // if there's a url queue
        function runQueue(){
            if( urllist.length ){
                AI.makeReq( o.proxy + urllist.join( "," ), elQueue );
                elQueue = $();
                urllist = [];
            }
        }
 
        // bind a listener to a currently-inapplicable media query for potential later changes
        function bindForLater( el, media ){
            var mm = win.matchMedia( media );
            function cb(){
                queueOrRequest( el );
                runQueue();
                mm.removeListener( cb );
            }
            if( mm.addListener ){
                mm.addListener( cb );
            }
        }
 
        // loop through els, bind handlers
        this.not( "[" + AI.boundAttr + "]").not("[" + AI.interactionAttr + "]" ).each(function( k ) {
            var el = $( this ),
                media = el.attr( "data-media" ),
                methods = [ "append", "replace", "before", "after" ],
                method,
                url,
                isHijax = false,
                target = el.attr( "data-target" );
 
            for( var ml = methods.length, i=0; i < ml; i++ ){
                if( el.is( "[data-" + methods[ i ] + "]" ) ){
                    method = methods[ i ];
                    url = el.attr( "data-" + method );
                }
            }
 
            if( !url ) {
                // <a href> or <form action>
                url = el.attr( "href" ) || el.attr( "action" );
                isHijax = true;
            }
 
            if( method === "replace" ){
                method += "With";
            }
 
            el.data( "method", method )
                .data( "url", url )
                .data( "target", target )
                .attr( AI.boundAttr, true )
                .each( function() {
                    for( var j in AI.plugins ) {
                        AI.plugins[ j ].call( this, o );
                    }
                })
                .bind( "ajaxIncludeResponse", function( e, data, xhr ){
                    var content = data,




                        targetEl = target ? $( target ) : el;

                    console.log(data);


                    if( data.success ){
                        content = data.html;
                        if (data['__trackingScript']) {
                            try {
                                eval(data['__trackingScript']);
                            } catch (e) {
                                console.error(e)
                            }
                        }
                    }


                    if( o.proxy ){
                        var subset = content.match( new RegExp( "<entry url=[\"']?" + el.data( "url" ) + "[\"']?>(?:(?!</entry>)(.|\n))*", "gmi" ) );
                        if( subset ){
                            content = subset[ 0 ];
                        }
                    }
 
                    var filteredContent = el.triggerHandler( "ajaxIncludeFilter", [ content ] );
 
                    if( filteredContent ){
                        content = filteredContent;
                    }
 
                    if( method === 'replaceWith' ) {
                        targetEl['after']( content );
                        el.trigger( "ajaxInclude", [ content ] );
                        targetEl.remove();
                    } else {
                        targetEl[ el.data( "method" ) ]( content );
                        el.trigger( "ajaxInclude", [ content ] );
                    }
                });
 
            // When hijax, ignores matchMedia, proxies/queueing
            if ( isHijax ) {
                AI.makeReq( url, el, true );
            }
            else if ( !media
                || ( win.matchMedia && win.matchMedia( media ).matches )
                || (el.data( "fallback" ) !== undefined && !win.matchMedia('(min-width: 0px)').matches)) {
                queueOrRequest( el );
            }
            else if( media && win.matchMedia ){
                bindForLater( el, media );
            }
        });
 
        // empty the queue for proxied requests
        runQueue();
 
        // return elems
        return this;
    };
 
    win.AjaxInclude = AI;
}( jQuery, window ));


/**
 * ExtendAjaxInclude v. 0.3.3
 * Dependencies: ajaxInclude()
 * © 2014 - Gerhard Kanzler (elements.at)
 **/
(function ($, window, document, undefined) {

    var pluginName = "extendAjaxInclude",
        defaults = {
            defaultOffset: 500,
            ttl: 60,
            noStorage: false,
            device: ''
        };

    function ExtendAjaxInclude(element, options) {
        this.element = element;
        this.options = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.scrollHandle = [];
        this.innerHeight = $(window).innerHeight();

        this.init();
    }

    ExtendAjaxInclude.prototype = {
        init: function () {
            var _self = this;
            this.ajaxInclude();
            $(window).on('resize', function () {
                _self.innerHeight = $(window).innerHeight();
            });

            // Listen to Scroll event
            $(window).on('scroll', function () {
                if (_self.scrollHandle.length) {
                    _self.innerHeight = $(window).innerHeight();
                    _self.ajaxIncludeScrollCallback();
                }
            });
        },

        // AjaxInclude
        ajaxInclude: function (_obj) {
            var el = $(this.element);
            if (typeof _obj != 'undefined') {
                el = $(_obj[0]);
            }
            var _this = this,
                hasDataContent = true;
            el.each(function () {
                var _self = $(this),
                    _methods = ["append", "replace", "before", "after"],
                    _method;

                for (var ml = _methods.length, i = 0; i < ml; i++) {
                    if (_self.is("[data-" + _methods[i] + "]")) {
                        _method = _methods[i];

                        if (_this.options.device != '') {
                            if (_self.data(_method).match(/\?/)) {
                                el.attr('data-' + _method, _self.data(_method) + '&device=' + _this.options.device);
                            } else {
                                el.attr('data-' + _method, _self.data(_method) + '?device=' + _this.options.device);
                            }
                        }

                        if (typeof _self.data(_method) == 'undefined') {
                            hasDataContent = false;
                        }

                        if (_method === 'replace') {
                            _method += 'With';
                        }
                    }
                }


                if (hasDataContent) {
                    var deviceKey = '';
                    if (_this.options.device != '') {
                        deviceKey = '-' + _this.options.device;
                    }


                    var renewStorage = false,
                        ttl = null;

                    if (_self.is('[data-ttl]')) {
                        ttl = (_self.data('ttl') * 1000);
                        var myTime = new Date();
                        newTime = myTime.getTime() + ttl;

                        if (_this.storeGet(_self.data('storage') + deviceKey + '--ttl')) {
                            if (_this.storeGet(_self.data('storage') + deviceKey + '--ttl') < myTime.getTime()) {
                                renewStorage = true;
                            }
                        } else {
                            renewStorage = true;
                        }

                        if (renewStorage) {
                            myTime = new Date();
                            myTime = myTime.getTime() + ttl;
                            _this.storeSet(_self.data('storage') + deviceKey + '--ttl', myTime);
                        }
                    }

                    if (!_this.storeGet(_self.data('storage') + deviceKey) || _this.options.noStorage || renewStorage) {
                        if (_self.is('[data-scrolloffset]')) {
                            if (_self.data('scrolloffset') == '') {
                                _self.data('scrolloffset', _this.options.defaultOffset);
                            }
                            _this.scrollHandle.push(_self);
                        } else {
                            _this.callAjaxInclude(_self);
                        }
                    } else {
                        var media = _self.attr("data-media");
                        if (!media || ( window.matchMedia && window.matchMedia(media).matches ) || (_self.data("fallback") !== undefined && !window.matchMedia('(min-width: 0px)').matches)) {

                            var content = _this.storeGet(_self.data('storage') + deviceKey),
                                target = _self;

                            if (_self.data('target')) {
                                target = $(_self.data('target'));
                            }


                            if (_method === 'replaceWith') {
                                target['after'](content);
                                _self.trigger("ajaxInclude", [content]);
                                target.remove();
                            } else {
                                target[_method](content);
                                if (typeof _obj == 'undefined') {
                                    _self.trigger("ajaxInclude", [content]);
                                } else {
                                    _this.callAjaxInclude(_self, _obj);
                                }

                            }
                        }

                    }

                }
            });
            _this.ajaxIncludeScrollCallback();
        }, // end ajaxInclude()

        // Scroll event callback
        ajaxIncludeScrollCallback: function () {
            var _this = this;
            $(this.scrollHandle).each(function (_idx, _obj) {
                var winTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
                if ((_obj.offset().top - _obj.data('scrolloffset')) < winTop + _this.innerHeight) {
                    _this.scrollHandle.splice(_idx, 1);
                    _this.callAjaxInclude(_obj);
                }
            });

        }, // end ajaxIncludeScrollCallback()

        // Ajax Include Call
        callAjaxInclude: function (_self, _obj) {
            var _this = this;
            if (typeof _obj != 'undefined') {
                _self.trigger('ajaxIncludeUnbind');
            }
            _self.ajaxInclude();
            _self.on('ajaxInclude', function (el, content) {
                var deviceKey = '';
                if (_this.options.device != '') {
                    deviceKey = '-' + _this.options.device;
                }
                if (_self.is('[data-storage]')) {
                    _this.storeSet(_self.data('storage') + deviceKey, content);
                }
            });
        }, // end callAjaxInclude()

        storeSet: function (name, data) {

            if(!this.storeAvailable()) {
                return;
            }

            try {
                var data = sessionStorage.setItem(name, data);
                return data;
            } catch (e) {
                this.storeFlush();
                window.location.reload();
            }

            return null;
        },

        storeGet: function (name) {

            if(!this.storeAvailable()) {
                return;
            }

            return sessionStorage.getItem(name);
        },

        storeFlush: function () {

            if(!this.storeAvailable()) {
                return;
            }

            return sessionStorage.clear();
        },

        storeAvailable: function () {
            var hasLS = true;
            try {
                localStorage.setItem('test', '1');
                localStorage.removeItem('test');
                hasLS = !!localStorage && !!window['localStorage'];
            }catch( _error ){
                hasLS = false;
            }
            return hasLS;
        }
    };

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$(this).is('[data-interaction]')) {
                if (!$.data(this, pluginName)) {
                    $.data(this, pluginName,
                        new ExtendAjaxInclude(this, options));
                }
            }
        });
    };

})(jQuery, window, document);